import { render, staticRenderFns } from "./HasFireplace.vue?vue&type=template&id=66e3c40f&"
import script from "./HasFireplace.vue?vue&type=script&lang=ts&"
export * from "./HasFireplace.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports